import { RouteConfig } from "vue-router";

// import CartConfirmDeliveryPage from "../views/pages/customer/mypage/cartConfirmDelivery.vue";
// import CartListPage from "../views/pages/customer/mypage/cartList.vue";
import CustomerCart from "@/views/pages/customer/cart.vue";
import CustomerHome from "@/views/pages/customer/home.vue";
import customerOrder from "@/views/pages/customer/order.vue";
import customerOrderThanks from "@/views/pages/customer/orderThanks.vue";
import CustomerLayout from "@/views/layouts/customer/qMaster.vue";
import {
  ADMIN_TYPE,
  CUSTOMER_TYPE,
  ROLE_ADMIN_CUSTOMER,
} from "@/common/constant";
import DemoDeliveryDestinationList from "@/components/cutomer/deliveryDestination/demoDeliveryDestinationList.vue";
import MypageIndex from "@/views/pages/customer/mypage/index.vue";
// import PurchaseEdit from "../views/pages/customer/mypage/purchaseEdit.vue";
// import PurchaseHistory from "../views/pages/customer/mypage/purchaseHistory.vue";
// import QuoteHistory from "../views/pages/customer/mypage/quoteHistory.vue";
// import OrderCompletePage from "../views/pages/customer/mypage/orderComplete.vue";
const customerRouter: Array<RouteConfig> = [
  {
    path: "",
    name: "front",
    component: CustomerLayout,
    meta: {
      allowRole: [ADMIN_TYPE, CUSTOMER_TYPE, ROLE_ADMIN_CUSTOMER],
    },
    children: [
      {
        path: "default",
        name: "customer.default",
        redirect: "home",
      },
      {
        path: "forbidden",
        name: "forbidden",
        component: () => import("../views/pages/errors/forbidden.vue"),
      },
      {
        path: "/",
        name: "front.home",
        component: CustomerHome,
        meta: {
          pageTitle: "株式会社HORIKOSHI",
          title: "製品一覧",
          subTitle: "",
          allowRole: [ADMIN_TYPE, CUSTOMER_TYPE, ROLE_ADMIN_CUSTOMER],
        },
      },
      {
        path: "carts",
        name: "customer.carts",
        component: CustomerCart,
        meta: {
          pageTitle: "カート内 製品一覧 | 株式会社HORIKOSHI",
          title: "カート内 製品一覧",
          subTitle: "",
          allowRole: [CUSTOMER_TYPE, ROLE_ADMIN_CUSTOMER],
        },
      },
      {
        path: "cart-delivery/list", // TODO: Demo delivery destination list
        name: "customer.delivery.list",
        component: DemoDeliveryDestinationList,
        meta: {
          pageTitle: "",
          title: "",
          subTitle: "",
          allowRole: [CUSTOMER_TYPE, ROLE_ADMIN_CUSTOMER],
        },
      },
      {
        path: "order",
        name: "customer.order",
        component: customerOrder,
        meta: {
          pageTitle: "ご注文手続き | 株式会社HORIKOSHI",
          title: "ご注文手続き",
          subTitle: "",
          allowRole: [CUSTOMER_TYPE, ROLE_ADMIN_CUSTOMER],
        },
      },
      {
        path: "order/:id",
        name: "customer.order_update",
        component: customerOrder,
        meta: {
          pageTitle: "ご注文手続き | 株式会社HORIKOSHI",
          title: "ご注文手続き",
          subTitle: "",
          allowRole: [CUSTOMER_TYPE, ROLE_ADMIN_CUSTOMER],
        },
      },
      {
        path: "order/:id/thanks",
        name: "customer.order_thanks",
        component: customerOrderThanks,
        meta: {
          pageTitle: "ご注文ありがとうございました | 株式会社HORIKOSHI",
          title: "ご注文完了",
          subTitle: "",
          allowRole: [CUSTOMER_TYPE, ROLE_ADMIN_CUSTOMER],
        },
      },
      {
        path: "my-page",
        name: "customer.mypage",
        component: MypageIndex,
        meta: {
          pageTitle: "マイページ | 株式会社HORIKOSHI",
          title: "マイページ",
          subTitle: "",
          allowRole: [CUSTOMER_TYPE, ROLE_ADMIN_CUSTOMER],
        },
      },
    ],
  },
  {
    path: "/error",
    name: "error",
    meta: {
      bodyClass: "ErrorBox",
    },
    component: () => import("../views/pages/error.vue"),
  },
  {
    path: "*",
    redirect: "not-found",
  },
  {
    path: "/not-found",
    name: "notFound",
    meta: {
      bodyClass: "ErrorBox",
    },
    component: () => import("../views/pages/notFound.vue"),
  },
];

export default customerRouter;
